import { LoadingSpinner } from 'components';
import StuffLayout from 'components/layouts/StuffLayout';
import { useAuth } from 'hooks/useAuth';
import { useSettings } from 'hooks/useSettings';
import { usePaymentMethods } from 'hooks/useUserMethods';
import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectStuff = () => {
  const { isLoggedIn, role, getUserProfile, authLoading } = useAuth();
  const {
    getAppSettings,
    isLoading: settingsLoading,
    getUserSettings,
  } = useSettings();
  const { isLoading: methodsLoading, getPaymentMethods } = usePaymentMethods();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getUserProfile();
    getPaymentMethods();
    getUserSettings();
    setLoaded(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isLoggedIn || role !== 'stuff') {
    return <Navigate to="/login" />;
  }

  if (!loaded || authLoading || methodsLoading || settingsLoading) {
    return <LoadingSpinner />;
  }
  return (
    <StuffLayout>
      <Outlet />
    </StuffLayout>
  );
};
export default ProtectStuff;
